// extracted by mini-css-extract-plugin
module.exports = {"container1":"YourAction_container1__3m08R","container2":"YourAction_container2__30fzs","card":"YourAction_card__2cly5","name":"YourAction_name__3wPni"};